import XLSX from 'xlsx'
import Download from 'downloadjs'

const download_xlsx = (jd_version, last_version_number) => {
	let workflowLabel = jd_version.label
	let workflowId = jd_version.descriptor_id
	let selectedVersionNumber = jd_version.version_number

	workflowLabel = workflowLabel.replace(/[\\/:"*?<>| ]+/g, '')
	let xlsxName = ''
	xlsxName += `batch_${workflowLabel}`
	xlsxName += `_ID-${workflowId}`
	xlsxName += `_V-${selectedVersionNumber}`
	if (last_version_number === selectedVersionNumber) {
		xlsxName += `_LAST`
	}
	xlsxName += `.xlsx`

	let batchHeaders = []
	let helpHeaders = []
	let jdHeaders = [
		'LABEL',
		'ID',
		'VERSION',
		'VERSION_ID',
		'DESCRIPTOR'
	]
	let batchColsWidths = []
	let helpColsWidths = []
	let jdColsWidths = [
		{ wch: 40 },
		{ wch: 5 },
		{ wch: 10 },
		{ wch: 14 },
		{ wch: 100 }
	]
	let batchData = [{}]
	let helpData = [{}, {}, {}, {}, {}]
	let jdData = [{}]

	jd_version.parameters.map(param => {
		let batchHeaderStr = param.name
		let helpHeaderStr = `[Paramètre] : ${param.name}`

		batchColsWidths.push({wch: batchHeaderStr.length + 1})
		let maxWidth = helpHeaderStr.length

		if (param.hasOwnProperty('help')) {
			let help = `[Aide] : ${param.help}`
			helpData[0][helpHeaderStr] = help
			if (help.length > maxWidth) {
				maxWidth = help.length
			}
		} else {
			helpData[0][helpHeaderStr] = '[Aide] : NC'
		}

		if (param.hasOwnProperty('required')) {
			if (param.required) {
				let required = '[Requis] : OUI'
				helpData[1][helpHeaderStr] = required
				if (required.length > maxWidth) {
					maxWidth = required.length
				}
			} else {
				helpData[1][helpHeaderStr] = '[Requis] : NON'
			}
		} else {
			helpData[1][helpHeaderStr] = '[Requis] : OUI'
		}

		if (param.hasOwnProperty('type')) {
			let type = `[Type] : ${param.type}`
			helpData[2][helpHeaderStr] = type
			if (type.length > maxWidth) {
				maxWidth = type.length
			}
			if (param.type === 'select' && param.hasOwnProperty('choices')) {
				let choices = []
				if (param.choices.length > 0) {
					if (Array.isArray(param.choices[0])) {
						param.choices.map(choice => {
							choices.push(choice[0])
						})
					} else {
						choices = param.choices
					}
				}
				let choicesString = `[Choix] : ${choices.join(', ')}`
				helpData[3][helpHeaderStr] = choicesString
				if (choicesString.length > maxWidth) {
					maxWidth = choicesString.length
				}
			} else {
				helpData[3][helpHeaderStr] = '[Choix] : NA'
			}
		} else {
			helpData[2][helpHeaderStr] = '[Type] : NC'
			helpData[3][helpHeaderStr] = '[Choix] : NC'
		}

		let defaultValue = ''
		if (param.default !== '') {
			defaultValue = param.default
			let defaultStr = `[Défaut] : ${param.default}`
			helpData[4][helpHeaderStr] = defaultStr
			if (defaultStr.length > maxWidth) {
				maxWidth = defaultStr.length
			}
		} else {
			helpData[4][helpHeaderStr] = '[Défaut] : NC'
		}

		helpColsWidths.push({wch: maxWidth + 1})
		batchHeaders.push(batchHeaderStr)
		helpHeaders.push(helpHeaderStr)
		batchData[0][batchHeaderStr] = defaultValue
	})

	jdData[0]['LABEL'] = jd_version.label
	jdData[0]['ID'] = jd_version.descriptor_id
	jdData[0]['VERSION'] = jd_version.version_number
	jdData[0]['VERSION_ID'] = jd_version.id
	jdData[0]['DESCRIPTOR'] = JSON.stringify(
		jd_version,
		null,
		2
	)

	let sheetBatch = XLSX.utils.json_to_sheet(
		batchData,
		{ header: batchHeaders }
	)
	sheetBatch['!cols'] = batchColsWidths

	let sheetHelp = XLSX.utils.json_to_sheet(
		helpData,
		{ header: helpHeaders }
	)
	sheetHelp['!cols'] = helpColsWidths

	let sheetJd = XLSX.utils.json_to_sheet(
		jdData,
		{ header: jdHeaders }
	)
	sheetJd['!cols'] = jdColsWidths
	/* eslint-disable new-cap */
	let wb = new XLSX.utils.book_new()
	wb.SheetNames.push('BATCH')
	wb.SheetNames.push('HELP')
	wb.SheetNames.push('JOB_DESCRIPTOR')
	wb.Sheets.BATCH = sheetBatch
	wb.Sheets.HELP = sheetHelp
	wb.Sheets.JOB_DESCRIPTOR = sheetJd
	let wopts = { bookType: 'xlsx', bookSST: true, type: 'array' }
	let wbout = XLSX.write(wb, wopts)
	let data = new Blob([wbout], {type: 'application/octet-stream'})
	Download(data, xlsxName)
}

const jobValidator = (job, params) => {
	// TODO WIP
	const isBoolean = (value) => {
		if (typeof (value) === 'boolean') {
			return true
		}
		return false
	}
	const isEmpty = (value) => {
		if (value === '' || value === null) {
			return true
		}
		return false
	}
	const isJsonString = (value) => {
		try {
			JSON.parse(value)
		} catch (e) {
			return false
		}
		return true
	}
	const isEmail = (value) => {
		if (/.+@.+/.test(value)) {
			return true
		}
		return false
	}
	const isFile = (value) => {
		value = value.replace(/\\/g, '/')
		if (value[value.length - 1] === '/') {
			return false
		}
		if (value.split('/').length === 1) {
			return false
		}
		return true
	}
	const isDirectory = (value) => {
		value = value.replace(/\\/g, '/')
		if (value[value.length - 1] !== '/') {
			return false
		}
		if (value.split('/').length <= 1) {
			return false
		}
		return true
	}
	const isPath = (value) => {
		value = value.replace(/\\/g, '/')
		if (value.split('/').length <= 1) {
			return false
		}
		return true
	}
	const isText = (value) => {
		if (typeof value === 'string' || value instanceof String) {
			return true
		}
		return false
	}
	let isValid = true
	let messages = []

	for (let currentParamName of Object.keys(job.params)) {
		let rule = params.find(param => param.name === currentParamName)
		var value = job.params[currentParamName]

		// if required is not specified (undefined), it is true (as stated by Maestro)
		if ((rule.required === true || rule.required === undefined) && isEmpty(value)) {
			messages.push(`${currentParamName} est un paramètre requis`)
			isValid = false
		}
		if (rule.type === 'boolean') {
			if (!isEmpty(value) && !isBoolean(value)) {
				messages.push(`${currentParamName} n'est pas un booléen`)
				isValid = false
			}
		}
		if (rule.type === 'directory') {
			if (!isEmpty(value) && !isDirectory(value)) {
				messages.push(`${currentParamName} n'est pas un chemin de dossier valide`)
				isValid = false
			}
			if (value) {
				value = window.vm.$paths.UNCToMaestro(value)
				job.params[currentParamName] = value
			}
		}
		if (rule.type === 'email') {
			if (!isEmpty(value) && !isEmail(value)) {
				messages.push(`${currentParamName} n'est pas un email valide`)
				isValid = false
			}
		}
		if (rule.type === 'file') {
			if (!isEmpty(value) && !isFile(value)) {
				messages.push(`${currentParamName} n'est pas un chemin de fichier valide`)
				isValid = false
			}
			if (value) {
				value = window.vm.$paths.UNCToMaestro(value)
				job.params[currentParamName] = value
			}
		}
		if (rule.type === 'path') {
			if (!isEmpty(value) && !isPath(value)) {
				messages.push(`${currentParamName} n'est pas un chemin valide`)
				isValid = false
			}
			if (value) {
				value = window.vm.$paths.UNCToMaestro(value)
				job.params[currentParamName] = value
			}
		}
		if (rule.type === 'integer') {
			if (!isEmpty(value) && !Number.isInteger(value)) {
				messages.push(`${currentParamName} n'est pas un nombre entier`)
				isValid = false
			}
		}
		if (rule.type === 'json') {
			if (!isEmpty(value) && !isJsonString(value)) {
				messages.push(`${currentParamName} n'est pas un json valide`)
				isValid = false
			}
		}
		if (rule.type === 'select') {
			if (!isEmpty(value)) {
				let choices = []
				if (rule.choices.length > 0) {
					if (Array.isArray(rule.choices[0])) {
						rule.choices.map(choice => {
							choices.push(choice[0])
						})
					} else {
						choices = rule.choices
					}
				}
				if (choices.indexOf(value) === -1) {
					messages.push(`${currentParamName} n'est pas inclus dans les choix [${choices.join(', ')}]`)
					isValid = false
				}
			}
		}
		if (rule.type === 'text') {
			if (!isEmpty(value) && !isText(value)) {
				messages.push(`${currentParamName} n'est pas un texte valide`)
				isValid = false
			}
		}
		// if (rule.type === 'date') {}
		// if (rule.type === 'datetime') {}
		// if (rule.type === 'url') {}
		// if (rule.type === 'multi-char') {}
		// if (rule.type === 'char') {}
		// if (rule.type === 'mutli-integer') {}
		// if (rule.type === 'multi-email') {}
		// if (rule.type === 'multi-url') {}
	}
	job.meta.valid = isValid
	job.meta.messages = messages
	return job
}

const read_xlsx = (file, params) => {
	return new Promise((resolve, reject) => {
		let warnings = []
		let errors = []
		let sheetData = []
		let sheetDataHead = []
		let selectedRows = []
		try {
			const reader = new FileReader()

			reader.onloadend = (e) => {
				let bstr = e.target.result
				let wb = XLSX.read(bstr, {type: 'binary'})
				for (var i in wb.SheetNames) {
					if (wb.SheetNames[i] === 'BATCH') {
						let sheet = wb.Sheets[wb.SheetNames[i]]
						let formatedCells = []
						for (const key in sheet) {
							if (key[0] !== '!') {
							// eslint-disable-next-line
								if (sheet[key].v != sheet[key].w) {
									formatedCells.push(key)
								}
							}
						}
						if (formatedCells.length > 0) {
							let message = ''
							if (formatedCells.length === 1) {
								message += `Attention 1 cellule semble avoir `
								message += `un format pouvant mener à une mauvaises valeur.<br />`
								message += `Veuillez vérifier la valeurs de la cellule :<br />`
								message += formatedCells[0]
							} else {
								message += `Attention ${formatedCells.length} `
								message += `cellule(s) semble(nt) avoir `
								message += `des formats pouvant mener à de mauvaises valeurs.<br />`
								message += `Veuillez vérifier les valeurs de(s) cellule(s) :<br />`
								message += formatedCells.join(', ')
							}
							warnings.push(message)
						}
						let jobs = XLSX.utils.sheet_to_json(sheet, {raw: true, defval: null})
						sheetData = jobs.map((job, indexJob) => {
							for (const key in job) {
								if (job[key] === 'true' || job[key] === 'TRUE') {
									job[key] = true
								}
								if (job[key] === 'false' || job[key] === 'FALSE') {
									job[key] = false
								}
							}
							let cells = {}
							Object.keys(job).map((key, index) => {
								cells[key] = String.fromCharCode(65 + index) + (indexJob + 2)
							})
							let warning = false
							Object.values(cells).map(cellValue => {
								if (formatedCells.indexOf(cellValue) > -1) {
									warning = true
								}
							})
							return {
								meta: {
									valid: false,
									warning: warning,
									messages: [],
									submitted: false
								},
								cells: cells,
								params: job
							}
						})
						sheetDataHead = Object.keys(jobs[0])
						let nbParams = params.length
						let found = 0
						if (sheetDataHead.length !== nbParams) {
							errors.push('Le nombre de colonnes ne correspond pas à ce workflow')
						} else {
							for (let i = 0; i < params.length; i++) {
								if (sheetDataHead.indexOf(params[i].name) > -1) {
									found++
								}
							}
							if (found !== nbParams) {
								errors.push('Les paramètres du batch ne semblent pas correspondre à ce workflow')
							}
						}
						if (errors.length === 0) {
							sheetData = sheetData.map((job, index) => {
								let validatedJob = jobValidator(job, params)
								if (validatedJob.meta.valid && !validatedJob.meta.warning) {
									selectedRows.push(index)
								}
								return validatedJob
							})
						}
						resolve({
							warnings: warnings,
							errors: errors,
							sheetData: sheetData,
							sheetDataHead: sheetDataHead,
							selectedRows: selectedRows
						})
						break
					}
				}
			}

			reader.readAsBinaryString(file)
		} catch (error) {
			reject(error)
		}
	})
}

const xlsx_to_tabulator = (file, params, unitary_to_batch_data) => {
	return new Promise((resolve, reject) => {
		let columns = []
		let deleteCol = {
			vertAlign: 'middle',
			hozAlign: 'center',
			minWidth: '30px',
			maxWidth: '30px',
			width: 30,
			headerSort: false,
			titleFormatter: (cell) => {
				return '<i class="v-icon material-icons theme--dark" style="font-size: 20px; cursor: pointer">close</i>'
			},
			headerClick: (e, column) => {
				e.stopPropagation()
				column.getTable().clearData()
			},
			formatter: (cell) => {
				return '<i class="v-icon material-icons theme--dark" style="font-size: 20px">close</i>'
			},
			tooltip: (cell) => {
				return 'Supprimer'
			},
			cellClick: (e, cell) => {
				e.stopPropagation()
				cell.getRow().delete()
			}
		}
		columns.push(deleteCol)
		for (const param of params) {
			let column = {}
			column.title = window.vm.$options.filters.snakeCase(param.name)
			column.field = param.name
			column.minWidth = '200px'
			column.validator = ['required']
			if (param.required || param.required === undefined) {
				column.validator.push('required')
			}
			if (param.type.indexOf('char') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-char') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('text') === 0) {
				column.editor = 'textarea'
			} else if (param.type.indexOf('assetid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-assetid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('url') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-url') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('integer') === 0) {
				column.editor = 'number'
			} else if (param.type.indexOf('float') === 0) {
				column.editor = 'number'
			} else if (param.type.indexOf('multi-integer') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('boolean') === 0) {
				column.editor = 'tickCross'
			} else if (param.type.indexOf('json') === 0) {
				column.editor = 'textarea'
			} else if (param.type.indexOf('select') === 0) {
				column.editor = 'select'
				let values = param.choices
				if (Array.isArray(values[0])) values = values.map(value => value[0])
				column.editorParams = { values: values, multiselect: false }
			} else if (param.type.indexOf('multi-select') === 0) {
				column.editor = 'select'
				let values = param.choices
				if (Array.isArray(values[0])) values = values.map(value => value[0])
				column.editorParams = { values: values, multiselect: true }
			} else if (param.type.indexOf('operatingzone') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('file') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('directory') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('path') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-file') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-directory') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-path') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('timecode') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('bundleid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-bundleid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('babelid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-babelid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('ownerid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-ownerid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('patronid') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('datetime') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('date') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('email') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('multi-email') === 0) {
				column.editor = 'input'
			} else if (param.type.indexOf('confplateformid') === 0) {
				column.editor = 'input'
			} else {
				column.editor = true
			}
			if (!param.group) {
				columns.push(column)
			} else {
				let group = columns.find(col => col.field === param.group)
				if (group) {
					group.columns.push(column)
				} else {
					group = {
						title: window.vm.$options.filters.snakeCase(param.group),
						field: param.group,
						columns: []
					}
					group.columns.push(column)
					columns.push(group)
				}
			}
		}

		columns.push({
			field: '_submitted',
			vertAlign: 'middle',
			hozAlign: 'center',
			minWidth: '30px',
			maxWidth: '30px',
			width: 30,
			headerSort: false,
			formatter: (cell) => {
				let rowData = cell.getRow().getData()
				if (rowData._error) {
					return `<i
						title="${rowData._error}"
						class="v-icon material-icons theme--dark error--text"
						style="font-size: 20px">
						report_problem
					</i>`
				}
				if (rowData._submitted) {
					return `<i
					class="v-icon material-icons theme--dark"
					style="font-size: 20px; color: #00E676">
					task_alt
				</i>`
				}
				return ''
			}
		})

		if (file) {
			try {
				const reader = new FileReader()
				reader.onload = (e) => {
					let buffer = e.target.result
					let wb = XLSX.read(buffer, { type: 'buffer' })
					if (wb.Sheets['BATCH']) {
						let jobs = XLSX.utils.sheet_to_json(wb.Sheets['BATCH'], {raw: true, defval: null})
						let data = jobs.map((job, indexJob) => {
							for (const key in job) {
								let param = params.find(param => param.name === key)
								let paramType = (param || {}).type
								if (paramType === 'path' || paramType === 'file' || paramType === 'directory') {
									if (job[key]) job[key] = window.vm.$paths.UNCToMaestro(job[key])
								}
								if (job[key] === 'true' || job[key] === 'TRUE' || job[key] === 'VRAI') {
									job[key] = true
								}
								if (job[key] === 'false' || job[key] === 'FALSE' || job[key] === 'FAUX') {
									job[key] = false
								}
							}
							job._submitted = false
							job._error = ''
							return job
						})
						resolve({ columns: columns, data: data })
					} else {
						throw new Error(`Feuille "BATCH" absente`)
					}
				}
				reader.readAsArrayBuffer(file)
			} catch (error) {
				reject(error)
			}
		} else if (unitary_to_batch_data) {
			console.log(unitary_to_batch_data)
			let line = { _submitted: false, _error: '', ...unitary_to_batch_data }
			resolve({ columns: columns, data: [line] })
		} else {
			resolve({ columns: columns, data: [] })
		}
	})
}

export default {
	download_xlsx,
	read_xlsx,
	xlsx_to_tabulator
}



// WEBPACK FOOTER //
// ./src/pages/maestro/launcher/launcher_xlsx.js